/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Trim_Duration_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Trim event duration" |
*
* @param {Event_Ad_Trim_Duration_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_trim_duration_aria_label = /** @type {((inputs?: Event_Ad_Trim_Duration_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Trim_Duration_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster la duree de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer des Trim-Ereignisses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riduci la durata dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длительность события обрезки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recortar la duración del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩短事件持续时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント期間をトリムする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रिम इवेंट अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração do evento de corte")
	return /** @type {LocalizedString} */ ("Trim event duration")
});